module.exports = __webpack_public_path__ + "frontend/img/structuralTransferability.a50458c1.svg";